import { fromJS } from 'immutable';
import { BAR, COLUMN, LINE, TABLE } from 'reporting-data/constants/chartTypes';
import { AGGREGATION, SEARCH } from 'reporting-data/constants/configTypes';
import { CRM_OBJECT } from 'reporting-data/constants/dataTypes';
import { MONTH } from 'reporting-data/constants/frequency';
import { AVG } from 'reporting-data/constants/metricTypes';
import { CURRENCY as CURRENCY_NUMBER_DISPLAY_HINT, DURATION as DURATION_NUMBER_DISPLAY_HINT, FORMATTED, PERCENTAGE, UNFORMATTED } from 'reporting-data/constants/numberDisplayHints';
import { BOOLEAN, CURRENCY as CURRENCY_METRIC_TYPE, DATE, DATE_TIME, DURATION as DURATION_METRIC_TYPE, ENUMERATION, NUMBER, STRING } from 'reporting-data/constants/property-types';
import { HUBSPOT_OWNER_ID } from 'reporting-data/constants/referenceTypes';
import { DESC } from 'reporting-data/constants/sortOrder';
export const createInsightReport = (columnName, objectTypeId, filterGroups, query) => fromJS({
  name: columnName,
  chartType: TABLE,
  config: {
    configType: SEARCH,
    dataType: CRM_OBJECT,
    objectTypeId,
    metrics: [{
      property: columnName
    }],
    filters: {
      filterGroups,
      query
    }
  }
});
const getPropertyTypeVizConfig = (selectedProperty, propertyType, numberDisplayHint) => {
  var _config$propertyType, _config$propertyType2;
  const config = {
    [NUMBER]: {
      [UNFORMATTED]: {
        metric: {
          property: selectedProperty
        },
        chartType: TABLE,
        configType: SEARCH
      },
      [FORMATTED]: {
        metric: {
          property: selectedProperty
        },
        dimensions: [HUBSPOT_OWNER_ID],
        chartType: BAR
      },
      [CURRENCY_NUMBER_DISPLAY_HINT]: {
        metric: {
          property: selectedProperty
        },
        dimensions: [HUBSPOT_OWNER_ID],
        chartType: BAR
      },
      [PERCENTAGE]: {
        metric: {
          property: selectedProperty,
          metricTypes: [AVG]
        },
        dimensions: [HUBSPOT_OWNER_ID],
        chartType: BAR
      },
      [DURATION_NUMBER_DISPLAY_HINT]: {
        metric: {
          property: selectedProperty
        },
        dimensions: [HUBSPOT_OWNER_ID],
        chartType: BAR
      }
    },
    [BOOLEAN]: {
      [FORMATTED]: {
        metric: {
          property: 'count'
        },
        dimensions: [selectedProperty],
        chartType: COLUMN
      }
    },
    [DATE]: {
      [FORMATTED]: {
        metric: {
          property: 'count'
        },
        dimensions: [selectedProperty],
        chartType: LINE
      }
    },
    [DATE_TIME]: {
      [FORMATTED]: {
        metric: {
          property: 'count'
        },
        dimensions: [selectedProperty],
        chartType: LINE
      }
    },
    [ENUMERATION]: {
      [FORMATTED]: {
        metric: {
          property: 'count'
        },
        dimensions: [selectedProperty],
        chartType: BAR
      }
    },
    [STRING]: {
      [FORMATTED]: {
        metric: {
          property: selectedProperty
        },
        chartType: TABLE,
        configType: SEARCH
      }
    },
    [CURRENCY_METRIC_TYPE]: {
      [FORMATTED]: {
        metric: {
          property: selectedProperty
        },
        dimensions: [HUBSPOT_OWNER_ID],
        chartType: BAR
      }
    },
    [DURATION_METRIC_TYPE]: {
      [FORMATTED]: {
        metric: {
          property: selectedProperty
        },
        dimensions: [HUBSPOT_OWNER_ID],
        chartType: BAR
      }
    }
  };
  return (_config$propertyType = (_config$propertyType2 = config[propertyType]) === null || _config$propertyType2 === void 0 ? void 0 : _config$propertyType2[numberDisplayHint !== null && numberDisplayHint !== void 0 ? numberDisplayHint : FORMATTED]) !== null && _config$propertyType !== void 0 ? _config$propertyType : undefined;
};
export const createVisualReport = (columnName, objectTypeId, filterGroups, query, propertyType, numberDisplayHint) => {
  if (!propertyType) {
    return null;
  }
  const vizConfig = getPropertyTypeVizConfig(columnName, propertyType, numberDisplayHint);
  if (!vizConfig) {
    return null;
  }
  const {
    metric,
    dimensions,
    chartType,
    configType
  } = vizConfig;
  return fromJS({
    name: columnName,
    chartType,
    config: {
      configType: configType !== null && configType !== void 0 ? configType : AGGREGATION,
      dataType: CRM_OBJECT,
      objectTypeId,
      metrics: [metric],
      dimensions: dimensions !== null && dimensions !== void 0 ? dimensions : [],
      filters: {
        filterGroups,
        query
      },
      frequency: MONTH,
      sort: [{
        property: metric.property,
        order: DESC
      }]
    }
  });
};